import { Alert, Button, Stack, TextField } from "@mui/material";
import { useMemo, useState } from "react";
import DialogHeader from "@entrilia/shared/components/dialog/DialogHeader.tsx";
import DialogButtons from "@entrilia/shared/components/DialogButtons.tsx";

import type { ReportGroup } from "../../../../../../api/types/svTypes.ts";

const ReportGroupForm = (props: {
  group: ReportGroup;
  groups?: ReportGroup[];
  title?: string;
  error?: string;
  saving: boolean;
  onCancel: () => void;
  onSave: (caption: string) => void;
}) => {
  const { group, title, groups, error, saving, onCancel, onSave } = props;
  const [caption, setCaption] = useState(group.caption);
  const [validationAllowed, setValidationAllowed] = useState(false);
  const [validateError, setValidateError] = useState<string>();

  const isNameValid = useMemo(() => {
    let errorText = "";
    const clearedInput = caption.trim();

    try {
      if (clearedInput.length < 2) {
        errorText = "Name should be at least 2 characters long.";
        return false;
      }
      const existGroup = groups?.find(
        (g) => g.caption.toLowerCase() === clearedInput.toLowerCase() && g.id !== group.id
      );
      if (existGroup !== undefined) {
        errorText = `Level with name ${clearedInput} already exists.`;
        return false;
      }
      return true;
    } finally {
      setValidateError(errorText);
    }
  }, [caption, group.id, groups]);

  const handleSave = () => onSave(caption.trim());

  return (
    <>
      <DialogHeader text={title || ""} disabled={saving} onClose={onCancel}></DialogHeader>
      <Stack spacing={2} useFlexGap sx={{ px: 2.5, py: 1, flex: 1, justifyContent: "center", width: "100%" }}>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField
          value={caption}
          onChange={(evt) => setCaption(evt.target.value)}
          error={validationAllowed && !isNameValid}
          helperText={(validationAllowed && validateError) || " "}
          label="Name"
          disabled={saving}
          onBlur={() => setValidationAllowed(true)}
          onKeyDown={(evt) => {
            if (evt.key === "Enter" && isNameValid) {
              handleSave();
            }
          }}
        />
      </Stack>
      <DialogButtons cancelDisabled={saving} onCancel={onCancel}>
        <Button variant="contained" disabled={saving || !isNameValid} loading={saving} onClick={handleSave}>
          Save
        </Button>
      </DialogButtons>
    </>
  );
};

export default ReportGroupForm;
